(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34455],{

/***/ 77326:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packs/[pack]",
      function () {
        return __webpack_require__(32615);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pack_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./redux/actions/packs.ts + 1 modules
var packs = __webpack_require__(37876);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/Hero/HeroSection.tsx
var HeroSection = __webpack_require__(87170);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./components/DateRangeForm/DateRangeForm.tsx + 1 modules
var DateRangeForm = __webpack_require__(4998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fab/Fab.js
var Fab = __webpack_require__(33758);
// EXTERNAL MODULE: ./node_modules/react-glider/dist/index.js
var dist = __webpack_require__(76142);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
;// CONCATENATED MODULE: ./components/Packs/PackProductCard.tsx










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: {
            cursor: 'pointer'
        },
        foot: {
            padding: theme.spacing(1, 2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(1)
        },
        title: {
            fontWeight: 700,
            lineHeight: 1.2
        },
        badge: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '90%',
            fontWeight: 700,
            lineHeight: 1,
            padding: '.25em',
            minWidth: '1.75em',
            height: '1.75em',
            borderRadius: '1.75em',
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        modalContent: {
            padding: theme.spacing(3)
        },
        modalMedias: {},
        modalDetails: _defineProperty({}, theme.breakpoints.up('sm'), {
            display: 'flex',
            justifYContent: 'center',
            alignItems: 'center'
        }),
        modalDetailsContent: (_obj = {
            padding: theme.spacing(1)
        }, _defineProperty(_obj, theme.breakpoints.up('sm'), {
            padding: theme.spacing(3)
        }), _defineProperty(_obj, '& iframe', {
            width: '100%'
        }), _obj),
        modalClose: {
            position: 'absolute',
            zIndex: 2,
            top: theme.spacing(1),
            right: theme.spacing(1),
            cursor: 'pointer',
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            boxShadow: theme.shadows[0],
            '&:hover, &:focus': {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white
            }
        }
    });
});
var PackProductCard = function(param) {
    var content = param.content, settings = param.settings;
    var ref12, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var LayoutStyle = {};
    var shopClasses = (0,Shop_style/* default */.Z)(LayoutStyle);
    var classes = useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref11 = (0,react.useState)(false), openModal = ref11[0], setOpenModal = ref11[1];
    var setOpenModalProduct = function() {
        var ref;
        setOpenModal(true);
        trackEvent({
            category: 'Packs',
            action: "Open Pack modale from ".concat(settings.currentUrl),
            name: (ref = content.product) === null || ref === void 0 ? void 0 : ref.name
        });
    };
    var setCloseModalProduct = function() {
        var ref;
        setOpenModal(false);
        trackEvent({
            category: 'Packs',
            action: "Close Pack modale from ".concat(settings.currentUrl),
            name: (ref = content.product) === null || ref === void 0 ? void 0 : ref.name
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (0,clsx_m/* default */.Z)('pack-product', classes.root, shopClasses.shopCard),
                onClick: setOpenModalProduct,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: 'pack-product__media',
                        "data-ratio": settings.ratio,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                            imagePaths: (ref12 = content.product) === null || ref12 === void 0 ? void 0 : ref12.images[0],
                            settings: {
                                quality: 75,
                                width: settings.cardWidth,
                                ar: (ref1 = settings.ratio) === null || ref1 === void 0 ? void 0 : ref1.substring(3)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)('pack-product__foot', classes.foot),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)('pack-product__title', classes.title),
                                variant: "body1",
                                component: "h2",
                                children: (ref2 = content.product) === null || ref2 === void 0 ? void 0 : ref2.name
                            }),
                            content.packProductQuantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (0,clsx_m/* default */.Z)('pack-product__badge', classes.badge),
                                children: [
                                    "x",
                                    content.packProductQuantity
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: openModal,
                fullScreen: settings.isMobile,
                onClose: function() {
                    return setOpenModal(false);
                },
                maxWidth: 'lg',
                className: 'pack-product-modal',
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    maxWidth: 'lg',
                    className: (0,clsx_m/* default */.Z)('pack-product-modal__content', classes.modalContent),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                            onClick: setCloseModalProduct,
                            className: (0,clsx_m/* default */.Z)('pack-product-modal__close', classes.modalClose),
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        className: (0,clsx_m/* default */.Z)('pack-product-modal__medias', classes.modalMedias),
                                        children: ((ref3 = content.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.images) === null || ref4 === void 0 ? void 0 : ref4.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                            hasArrows: true,
                                            draggable: true,
                                            scrollLock: true,
                                            slidesToShow: 1,
                                            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                            children: (ref5 = content.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.images) === null || ref6 === void 0 ? void 0 : ref6.map(function(image, index) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        "data-ratio": settings.ratio,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                            settings: {
                                                                quality: 75,
                                                                width: settings.largeImgWidth,
                                                                ar: (ref = settings.ratio) === null || ref === void 0 ? void 0 : ref.substring(3)
                                                            },
                                                            imagePaths: image
                                                        })
                                                    })
                                                }, index);
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-ratio": settings.ratio,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                settings: {
                                                    quality: 75,
                                                    width: settings.largeImgWidth,
                                                    ar: (ref7 = settings.ratio) === null || ref7 === void 0 ? void 0 : ref7.substring(3)
                                                },
                                                imagePaths: (ref8 = content.product) === null || ref8 === void 0 ? void 0 : ref8.images[0]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        className: (0,clsx_m/* default */.Z)('pack-product-modal__details', classes.modalDetails),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)('pack-product-modal__details-content', classes.modalDetailsContent),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    component: "div",
                                                    gutterBottom: true,
                                                    className: "pack-product-modal__title",
                                                    children: (ref9 = content.product) === null || ref9 === void 0 ? void 0 : ref9.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    component: 'div',
                                                    className: "pack-product-modal__desc",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: (ref10 = content.product) === null || ref10 === void 0 ? void 0 : ref10.description
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Packs_PackProductCard = (PackProductCard);

// EXTERNAL MODULE: ./components/Sizes/SizeModal.tsx + 4 modules
var SizeModal = __webpack_require__(26035);
// EXTERNAL MODULE: ./utils/usePackAvailability.tsx
var usePackAvailability = __webpack_require__(20030);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/Shop/BottomMenuLinks.tsx
var BottomMenuLinks = __webpack_require__(7395);
// EXTERNAL MODULE: ./components/Shop/CommonInformations.tsx + 1 modules
var CommonInformations = __webpack_require__(55407);
// EXTERNAL MODULE: ./components/InStore/ChangeStoreModal.tsx
var ChangeStoreModal = __webpack_require__(63052);
// EXTERNAL MODULE: ./components/InStore/InStoreSoldOut.tsx
var InStoreSoldOut = __webpack_require__(67866);
// EXTERNAL MODULE: ./components/Packs/PackPriceFormat.tsx + 1 modules
var PackPriceFormat = __webpack_require__(28868);
// EXTERNAL MODULE: ./components/Shop/ProductCard.tsx + 4 modules
var ProductCard = __webpack_require__(18496);
;// CONCATENATED MODULE: ./components/Global/ProductCardSkeleton.tsx




function ProductCardSkeleton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ProductCardSkeleton_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            marginBottom: theme.spacing(3)
        },
        col: {},
        md5: ProductCardSkeleton_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        })
    });
});
var ProductCardSkeleton = function(param) {
    var isFiveColumns = param.isFiveColumns, gridItemWidth = param.gridItemWidth, aspectRatio = param.aspectRatio;
    var classes = ProductCardSkeleton_useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            container: true,
            spacing: 3,
            className: classes.root,
            children: Array.from(new Array(5)).map(function(el, index) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 6,
                    lg: isFiveColumns ? 2 : gridItemWidth,
                    className: isFiveColumns ? classes.md5 : classes.col,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                "data-ratio": aspectRatio,
                                variant: "rect"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "16ch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "5ch"
                            })
                        ]
                    })
                }, index));
            })
        })
    }));
};
/* harmony default export */ var Global_ProductCardSkeleton = (ProductCardSkeleton);

;// CONCATENATED MODULE: ./components/Packs/PackRelatedProducts.tsx







function PackRelatedProducts_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PackRelatedProducts_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        packProductTitle: {
            marginBottom: theme.spacing(3)
        },
        relatedTitle: {
            margin: theme.spacing(0, 0, 2)
        },
        col: {},
        md5: PackRelatedProducts_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        associationRow: {
            marginBottom: theme.spacing(3)
        }
    });
});
var PackRelatedProducts = function(param) {
    var associations = param.associations, packs = param.packs, relatedProductsTitle = param.relatedProductsTitle, aspectRatio = param.aspectRatio, gridItemWidth = param.gridItemWidth, isFiveColumns = param.isFiveColumns, t = param.t, generalRes = param.generalRes, cardWidth = param.cardWidth, singleProductRes = param.singleProductRes, stock = param.stock, addToCartButtonOnAssociatedItem = param.addToCartButtonOnAssociatedItem, promotions = param.promotions;
    var relatedProductsClasses = PackRelatedProducts_useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 'xl',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)('pack-related'),
            children: Object.keys(associations).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h3',
                        component: 'h2',
                        className: (0,clsx_m/* default */.Z)('pack-related__title', relatedProductsClasses.relatedTitle),
                        children: !packs.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: relatedProductsTitle,
                            defaultText: t('texts:single_product:associations_title')
                        })
                    }),
                    !packs.loading ? associations === null || associations === void 0 ? void 0 : associations.map(function(association, index1) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            spacing: 3,
                            className: relatedProductsClasses.associationRow,
                            children: association.products.map(function(relatedProduct, index) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 6,
                                    lg: isFiveColumns ? 2 : gridItemWidth,
                                    className: isFiveColumns ? relatedProductsClasses.md5 : relatedProductsClasses.col,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                        settings: generalRes,
                                        stock: stock,
                                        text: singleProductRes,
                                        productCode: relatedProduct.code,
                                        slug: relatedProduct.slug,
                                        name: relatedProduct.name,
                                        thumb: relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.images[0],
                                        thumbRatio: aspectRatio,
                                        thumbWidth: cardWidth,
                                        product: relatedProduct,
                                        addButton: addToCartButtonOnAssociatedItem,
                                        isRelated: true,
                                        promotions: promotions,
                                        fromPack: true
                                    })
                                }, index));
                            })
                        }, index1));
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Global_ProductCardSkeleton, {
                        isFiveColumns: isFiveColumns,
                        gridItemWidth: gridItemWidth,
                        aspectRatio: aspectRatio
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Packs_PackRelatedProducts = (PackRelatedProducts);

// EXTERNAL MODULE: ./components/BackInStockAlert/BackInStockAlert.tsx
var BackInStockAlert = __webpack_require__(99871);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./redux/adapter/packs/packAdapter.tsx + 3 modules
var packAdapter = __webpack_require__(52404);
// EXTERNAL MODULE: ./components/Products/NoMixedBasketModal.tsx
var NoMixedBasketModal = __webpack_require__(16372);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
;// CONCATENATED MODULE: ./pages/packs/[pack].tsx
/* provided dependency */ var process = __webpack_require__(34155);




































function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _pack_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _pack_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _pack_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        prev: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        main: {
            padding: theme.spacing(3, 0)
        },
        loadingImg: {
            display: 'block',
            maxWidth: '100%',
            height: 480,
            borderRadius: theme.shape.borderRadius
        },
        imgShape: {
            borderRadius: theme.shape.borderRadius
        },
        skeletonText: {
            transform: 'none'
        },
        packHead: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(2)
        },
        packContent: _pack_defineProperty({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            padding: theme.spacing(1, 0, 2)
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(3)
        }),
        desc: {},
        packProductTitle: {
            marginBottom: theme.spacing(3)
        },
        relatedTitle: {
            margin: theme.spacing(0, 0, 2)
        },
        col: {},
        md5: _pack_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        associationRow: {
            marginBottom: theme.spacing(3)
        }
    });
});
var mapStateToProps = function(state) {
    return {
        packs: state.packs,
        taxonPack: state.taxonPack,
        parameters: state.parameters,
        promotions: state.promotions,
        cart: state.cart,
        stock: state.stock,
        stores: state.stores,
        takeBackLP: state.takeBack
    };
};
var mapDispatchToProps = {
    getPackTaxons: packs/* getPackTaxons */.Ht,
    getPacksByPackTaxonId: packs/* getPacksByPackTaxonId */.M9,
    saveCurrentPack: packs/* saveCurrentPack */.VH,
    deletePackOrigin: packs/* deletePackOrigin */.NX
};
var Pack = function(param) {
    var packs = param.packs, taxonPack = param.taxonPack, getPackTaxons1 = param.getPackTaxons, getPacksByPackTaxonId1 = param.getPacksByPackTaxonId, generalRes = param.generalRes, funnel = param.funnel, inStoreText = param.inStoreText, parameters = param.parameters, packSettings = param.packSettings, takeback = param.takeback, promotions = param.promotions, cart = param.cart, packsTexts = param.packsTexts, stock = param.stock, saveCurrentPack1 = param.saveCurrentPack, deletePackOrigin1 = param.deletePackOrigin, basket = param.basket, singleProductRes = param.singleProductRes, stores = param.stores, accountRes = param.accountRes, faqRes = param.faqRes, banner = param.banner, takeBackLP = param.takeBackLP;
    var ref35, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var addMultipleProductToCart = (0,useCart/* useCart */.j)().addMultipleProductToCart;
    var LayoutStyle = {};
    var classes = (0,Shop_style/* default */.Z)(LayoutStyle);
    var packClasses = _pack_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref25 = (0,useMatomo/* default */.Z)(), trackEvent = ref25.trackEvent, trackPageView = ref25.trackPageView;
    var currentSlug = router.query.pack;
    var ref26 = (0,react.useState)(''), currentUrl = ref26[0], setCurrentUrl = ref26[1];
    var ref27 = (0,react.useState)(true), fromApp = ref27[0], setFromApp = ref27[1];
    var ref28 = (0,react.useState)(true), packLoading = ref28[0], setPackLoading = ref28[1];
    var ref29 = (0,react.useState)(), currentPack = ref29[0], setCurrentPack = ref29[1];
    var ref30 = (0,react.useState)(0), minPrice1 = ref30[0], setMinPrice = ref30[1];
    var ref31 = (0,react.useState)(false), openModal = ref31[0], setOpenModal = ref31[1];
    var ref32 = (0,react.useState)(false), openInStoreModal = ref32[0], setOpenInStoreModal = ref32[1];
    var ref33 = (0,react.useState)([]), selection1 = ref33[0], setSelection = ref33[1];
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var displayHero = packSettings === null || packSettings === void 0 ? void 0 : (ref35 = packSettings.data) === null || ref35 === void 0 ? void 0 : ref35.display_hero_section;
    var thumbWidth = generalRes === null || generalRes === void 0 ? void 0 : (ref1 = generalRes.data) === null || ref1 === void 0 ? void 0 : ref1.small_image_size;
    var cardWidth = generalRes === null || generalRes === void 0 ? void 0 : (ref2 = generalRes.data) === null || ref2 === void 0 ? void 0 : ref2.medium_image_size;
    var largeImgWidth = generalRes === null || generalRes === void 0 ? void 0 : (ref3 = generalRes.data) === null || ref3 === void 0 ? void 0 : ref3.large_image_size;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(generalRes === null || generalRes === void 0 ? void 0 : generalRes.data.thumbnail_ratio);
    var ref34 = (0,utils/* columnGridLayout */.YF)(packSettings === null || packSettings === void 0 ? void 0 : (ref4 = packSettings.data) === null || ref4 === void 0 ? void 0 : ref4.column_layout), columnLeft = ref34.columnLeft, columnRight = ref34.columnRight;
    var packFullyLoaded = currentPack !== undefined;
    var packState = (0,usePackAvailability/* usePackAvailability */.J)(generalRes === null || generalRes === void 0 ? void 0 : (ref5 = generalRes.data) === null || ref5 === void 0 ? void 0 : ref5.add_pack_if_complete, currentPack === null || currentPack === void 0 ? void 0 : currentPack.packProducts, stock);
    var discountPriceFormat = generalRes === null || generalRes === void 0 ? void 0 : (ref6 = generalRes.data) === null || ref6 === void 0 ? void 0 : ref6.discounted_price_display_format;
    var addToCartBtnOpts = (0,utils/* btnOptions */.gY)(packSettings === null || packSettings === void 0 ? void 0 : (ref7 = packSettings.data) === null || ref7 === void 0 ? void 0 : ref7.add_to_cart_button);
    var showRelatedProducts = packSettings === null || packSettings === void 0 ? void 0 : (ref8 = packSettings.data) === null || ref8 === void 0 ? void 0 : ref8.display_associations;
    var addToCartButtonOnAssociatedItem = packSettings === null || packSettings === void 0 ? void 0 : (ref9 = packSettings.data) === null || ref9 === void 0 ? void 0 : ref9.display_add_to_cart_button_on_associated_item;
    var associations = currentPack && currentPack.productsAssociations;
    var relatedProductsTitle = packSettings === null || packSettings === void 0 ? void 0 : (ref10 = packSettings.data) === null || ref10 === void 0 ? void 0 : ref10.association_text;
    var gridItemWidth = (0,utils/* columnLayout */.Zd)(generalRes === null || generalRes === void 0 ? void 0 : generalRes.data.page_shop_desktop_columns);
    var isFiveColumns = gridItemWidth === '20%';
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref11 = parameters.items) === null || ref11 === void 0 ? void 0 : ref11.enableChooseStartingDate;
    var baseUrl =  true && window.location.origin ? window.location.origin : '';
    var warehouseId = (stores === null || stores === void 0 ? void 0 : (ref12 = stores.selectedStore) === null || ref12 === void 0 ? void 0 : ref12.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref13 = stores.selectedStore) === null || ref13 === void 0 ? void 0 : ref13.warehouseId : process.env.CUSTOM_WAREHOUSE ? process.env.CUSTOM_WAREHOUSE : null;
    var currentFullUrl = baseUrl + router.asPath;
    //For now the stock alert is made only for sub stores
    var showStockAlert = constants/* isSubscription */.Nn;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        generalRes,
        inStoreText
    ]);
    (0,react.useEffect)(function() {
        if (router.isReady) {
            setCurrentUrl(router.asPath);
        }
    }, [
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        // If the single pack is visited on first page load, we need to fetch all the pack with help of pack taxons
        if (!taxonPack.items) {
            getPackTaxons1();
        } else {
            if ((packs === null || packs === void 0 ? void 0 : packs.origin) !== 'packs') {
                var fetchAllPacks = function() {
                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, ref, packsLoaded, filteredPack;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _ctx.prev = 1;
                                    _iterator = taxonPack.items[Symbol.iterator]();
                                case 3:
                                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                        _ctx.next = 17;
                                        break;
                                    }
                                    item = _step.value;
                                    ;
                                    _ctx.next = 8;
                                    return getPacksByPackTaxonId1(item.id);
                                case 8:
                                    packsLoaded = _ctx.sent;
                                    filteredPack = packsLoaded === null || packsLoaded === void 0 ? void 0 : (ref = packsLoaded.packs) === null || ref === void 0 ? void 0 : ref.filter(function(pack) {
                                        return pack.slug === currentSlug;
                                    });
                                    if (!(filteredPack.length > 0)) {
                                        _ctx.next = 14;
                                        break;
                                    }
                                    setCurrentPack((0,packAdapter/* PackAdapter */.O)(filteredPack[0]));
                                    saveCurrentPack1(filteredPack);
                                    return _ctx.abrupt("break", 17);
                                case 14:
                                    _iteratorNormalCompletion = true;
                                    _ctx.next = 3;
                                    break;
                                case 17:
                                    _ctx.next = 23;
                                    break;
                                case 19:
                                    _ctx.prev = 19;
                                    _ctx.t0 = _ctx["catch"](1);
                                    _didIteratorError = true;
                                    _iteratorError = _ctx.t0;
                                case 23:
                                    _ctx.prev = 23;
                                    _ctx.prev = 24;
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                case 26:
                                    _ctx.prev = 26;
                                    if (!_didIteratorError) {
                                        _ctx.next = 29;
                                        break;
                                    }
                                    throw _iteratorError;
                                case 29:
                                    return _ctx.finish(26);
                                case 30:
                                    return _ctx.finish(23);
                                case 31:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                1,
                                19,
                                23,
                                31
                            ],
                            [
                                24,
                                ,
                                26,
                                30
                            ]
                        ]);
                    }));
                    return function fetchAllPacks() {
                        return _ref.apply(this, arguments);
                    };
                }();
                fetchAllPacks();
                setPackLoading(false);
            } else {
                var ref36;
                setCurrentPack(packs === null || packs === void 0 ? void 0 : (ref36 = packs.items) === null || ref36 === void 0 ? void 0 : ref36.find(function(el) {
                    return el.slug === currentSlug;
                }));
                setPackLoading(false);
                deletePackOrigin1();
            }
        }
    }, [
        currentSlug,
        taxonPack.items
    ]);
    (0,react.useEffect)(function() {
        if (currentPack) {
            var minPrice = (0,utils/* calcPackMinPrice */.hQ)(currentPack === null || currentPack === void 0 ? void 0 : currentPack.packProducts);
            setMinPrice(minPrice);
            trackPageView({
                documentTitle: currentPack.name
            });
        }
    }, [
        currentPack,
        promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion
    ]);
    (0,react.useEffect)(function() {
        // Turns out that opening a tab start your history at 1
        if (window.history.length <= 2) {
            setFromApp(false);
        }
    }, [
        fromApp
    ]);
    var handleBack = function() {
        fromApp ? router.back() : router.push('/packs');
    };
    // add pack with all variants
    var AddMultipleProductsToCart = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(selection) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // add selection to cart
                        trackEvent({
                            category: 'Packs',
                            action: "Add products to cart from single pack : ".concat(currentPack === null || currentPack === void 0 ? void 0 : currentPack.name)
                        });
                        _ctx.next = 3;
                        return addMultipleProductToCart({
                            items: selection
                        });
                    case 3:
                        setSelection([]);
                        setOpenModal(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function AddMultipleProductsToCart(selection) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseInStoreModal = function() {
        setOpenInStoreModal(false);
    };
    var handleOpenInStoreModal = function() {
        setOpenInStoreModal(true);
    };
    var currentPackSKUs = currentPack && currentPack.packProducts.map(function(unit) {
        var ref, ref38;
        var productSKU = ((ref = unit.product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 ? [
            unit.product.variants[0].sku
        ] : (ref38 = unit.product.variants) === null || ref38 === void 0 ? void 0 : ref38.map(function(variant) {
            return variant.sku;
        });
        return productSKU;
    });
    var shortProducts = stock === null || stock === void 0 ? void 0 : (ref14 = stock.stock) === null || ref14 === void 0 ? void 0 : ref14.filter(function(stockUnit) {
        for(var i = 0; i < (currentPackSKUs === null || currentPackSKUs === void 0 ? void 0 : currentPackSKUs.length); i++){
            var ref;
            if ((ref = currentPackSKUs[i]) === null || ref === void 0 ? void 0 : ref.includes(stockUnit.lizeeSKU)) {
                return stockUnit;
            }
        }
    }).map(function(unit) {
        return {
            sku: unit.lizeeSKU,
            quantity: unit.quantity
        };
    });
    var PackAddToCart = function() {
        var ref, ref39, ref40;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !packState.soldOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: 'pack-choose-button',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: function() {
                        return setOpenModal(true);
                    },
                    color: "secondary",
                    variant: 'contained',
                    size: isMobile ? 'small' : 'medium',
                    "data-testid": 'pack-choose-button',
                    className: 'pack-choose-button',
                    disabled: currentPack && currentPack.packProducts.length === 0 || cart.loading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: packSettings === null || packSettings === void 0 ? void 0 : (ref = packSettings.data) === null || ref === void 0 ? void 0 : ref.choose_button,
                        defaultText: t('texts:pack_single:choose')
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !(parameters === null || parameters === void 0 ? void 0 : (ref39 = parameters.items) === null || ref39 === void 0 ? void 0 : ref39.in_store) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h4',
                        component: 'h2',
                        className: (0,clsx_m/* default */.Z)('pack__unavailable', "pack__unavailable__".concat(currentPack === null || currentPack === void 0 ? void 0 : currentPack.code)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: packSettings === null || packSettings === void 0 ? void 0 : (ref40 = packSettings.data) === null || ref40 === void 0 ? void 0 : ref40.sold_out,
                            defaultText: t('texts:pack_single:sold_out')
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreSoldOut/* default */.Z, {
                        datas: inStoreText,
                        isPack: true,
                        handleOpenInStoreModal: handleOpenInStoreModal,
                        defaultText: {
                            title: t('texts:instore:pack_not_available'),
                            desc: t('texts:instore:paragraph'),
                            cta: t('texts:instore:change_store_cta')
                        }
                    }),
                    showStockAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert/* default */.Z, {
                        singleProductPrismicData: singleProductRes === null || singleProductRes === void 0 ? void 0 : singleProductRes.data,
                        products: shortProducts,
                        url: currentFullUrl,
                        warehouseId: warehouseId,
                        isPack: true
                    })
                ]
            })
        });
    };
    var PackDesc = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                component: 'div',
                className: (0,clsx_m/* default */.Z)('pack__desc', classes.shopApiContent, packClasses.desc),
                children: packFullyLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: currentPack === null || currentPack === void 0 ? void 0 : currentPack.description
                    }
                }) : /* Loading Paragraphs */ Array.from(new Array(12)).map(function(el, index) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "text",
                        width: "".concat(Math.floor(Math.random() * 100) + 1, "%")
                    }, index + 1));
                })
            })
        });
    };
    return packLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        mainLogo: generalRes === null || generalRes === void 0 ? void 0 : (ref15 = generalRes.data) === null || ref15 === void 0 ? void 0 : ref15.logo,
        t: t,
        doc: generalRes,
        inStoreText: inStoreText,
        metaTitle: currentPack === null || currentPack === void 0 ? void 0 : currentPack.name,
        basket: basket,
        takeback: takeback,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (0,clsx_m/* default */.Z)(classes.root, 'page--pack'),
                children: [
                    !isMobile && !displayHero && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                        title: (0,CMSText/* prismicText */.yz)(generalRes === null || generalRes === void 0 ? void 0 : (ref16 = generalRes.data) === null || ref16 === void 0 ? void 0 : ref16.baseline, t('texts:general:baseline')),
                        heroImg: generalRes === null || generalRes === void 0 ? void 0 : (ref17 = generalRes.data) === null || ref17 === void 0 ? void 0 : ref17.hero_banner,
                        heroSettings: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (0,clsx_m/* default */.Z)('pack__content', classes.shopContent, classes.shopContentSingle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            maxWidth: "xl",
                            className: (0,clsx_m/* default */.Z)('product__container', classes.shopContainer),
                            children: [
                                !constants/* isSubscription */.Nn && !isMobile && !displayHero || isEnableChooseStartingDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)('shop__planner', classes.shopPlanner, classes.shopPlannerDad),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeForm/* default */.Z, {
                                        text: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
                                        textFunnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                        t: t,
                                        parameters: parameters,
                                        scrollTarget: 'pack-single'
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                    maxWidth: "xl",
                                    className: (0,clsx_m/* default */.Z)('product__area', classes.shopArea, classes.shopAreaSingle),
                                    id: 'pack-single',
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)('pack__prev', packClasses.prev),
                                            variant: "outlined",
                                            color: "secondary",
                                            onClick: function() {
                                                return handleBack();
                                            },
                                            size: "small",
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: generalRes === null || generalRes === void 0 ? void 0 : (ref18 = generalRes.data) === null || ref18 === void 0 ? void 0 : ref18.previous_button,
                                                defaultText: t('texts:general:previous_button')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            className: (0,clsx_m/* default */.Z)('pack__main', packClasses.main),
                                            spacing: isMobile ? 4 : 8,
                                            "data-testid": packFullyLoaded ? 'pack-loaded' : 'pack-loading',
                                            children: [
                                                packFullyLoaded && ((ref19 = currentPack.images) === null || ref19 === void 0 ? void 0 : ref19.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, _objectSpread({
                                                    item: true,
                                                    className: "pack__left"
                                                }, columnLeft, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        "data-ratio": aspectRatio,
                                                        children: packFullyLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                            classes: (0,clsx_m/* default */.Z)('pack__image', packClasses.imgShape),
                                                            imagePaths: currentPack.images[0],
                                                            settings: {
                                                                quality: 75,
                                                                width: largeImgWidth,
                                                                ar: aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.substring(3)
                                                            }
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            variant: "rect",
                                                            className: packClasses.loadingImg
                                                        })
                                                    })
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, _objectSpread({
                                                    item: true,
                                                    className: "pack__right"
                                                }, packFullyLoaded && ((ref20 = currentPack.images) === null || ref20 === void 0 ? void 0 : ref20.length) > 0 ? _objectSpread({}, columnRight) : {
                                                    xs: 12
                                                }, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)('pack__content', packClasses.packContent),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (0,clsx_m/* default */.Z)('pack__head', packClasses.packHead),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "pack__title",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            variant: 'h2',
                                                                            component: 'h1',
                                                                            children: packFullyLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: currentPack === null || currentPack === void 0 ? void 0 : currentPack.name
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                                variant: "text",
                                                                                className: packClasses.skeletonText
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (0,clsx_m/* default */.Z)('pack__price', "pack__price__".concat(currentPack === null || currentPack === void 0 ? void 0 : currentPack.code)),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PackPriceFormat/* default */.Z, {
                                                                            promotions: promotions,
                                                                            settings: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
                                                                            minPrice: minPrice1,
                                                                            discountPriceFormat: discountPriceFormat,
                                                                            isDisplayPercentage: true
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            addToCartBtnOpts === 'Both' && /*#__PURE__*/ (0,jsx_runtime.jsx)(PackAddToCart, {}),
                                                            addToCartBtnOpts === 'Above' && /*#__PURE__*/ (0,jsx_runtime.jsx)(PackAddToCart, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PackDesc, {}),
                                                            addToCartBtnOpts === 'Both' && /*#__PURE__*/ (0,jsx_runtime.jsx)(PackAddToCart, {}),
                                                            addToCartBtnOpts === 'Below' && /*#__PURE__*/ (0,jsx_runtime.jsx)(PackAddToCart, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "commonInformations__".concat(currentPack === null || currentPack === void 0 ? void 0 : currentPack.code),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonInformations/* default */.Z, {
                                                                    datas: generalRes === null || generalRes === void 0 ? void 0 : (ref21 = generalRes.data) === null || ref21 === void 0 ? void 0 : ref21.common_informations,
                                                                    layout: generalRes === null || generalRes === void 0 ? void 0 : (ref22 = generalRes.data) === null || ref22 === void 0 ? void 0 : ref22.common_informations_layout
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomMenuLinks/* default */.Z, {
                                                                datas: generalRes === null || generalRes === void 0 ? void 0 : (ref23 = generalRes.data) === null || ref23 === void 0 ? void 0 : ref23.bottom_menu_links
                                                            })
                                                        ]
                                                    })
                                                }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h3",
                                                        component: 'h2',
                                                        className: (0,clsx_m/* default */.Z)('pack__products-title', packClasses.packProductTitle),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: packSettings === null || packSettings === void 0 ? void 0 : (ref24 = packSettings.data) === null || ref24 === void 0 ? void 0 : ref24.pack_content_title,
                                                            defaultText: t('texts:pack_single:pack_content_title')
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 3,
                                                        children: currentPack === null || currentPack === void 0 ? void 0 : currentPack.packProducts.map(function(packProduct, index) {
                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                xs: 6,
                                                                lg: 3,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Packs_PackProductCard, {
                                                                    content: packProduct,
                                                                    settings: {
                                                                        ratio: aspectRatio,
                                                                        cardWidth: cardWidth,
                                                                        largeImgWidth: largeImgWidth,
                                                                        isMobile: isMobile,
                                                                        currentUrl: currentUrl
                                                                    }
                                                                })
                                                            }, index));
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            packFullyLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeModal/* default */.Z, {
                open: openModal,
                handleClose: function() {
                    return setOpenModal(false);
                },
                type: 'pack',
                text: packsTexts.data,
                stock: stock,
                products: currentPack === null || currentPack === void 0 ? void 0 : currentPack.packProducts,
                cart: cart,
                AddMultipleProductsToCart: AddMultipleProductsToCart,
                thumbRatio: aspectRatio,
                thumbWidth: thumbWidth,
                isMobile: isMobile,
                settings: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
                selection: selection1,
                setSelection: setSelection,
                takeback: takeback,
                takeBackLP: takeBackLP
            }),
            showRelatedProducts && associations && /*#__PURE__*/ (0,jsx_runtime.jsx)(Packs_PackRelatedProducts, {
                associations: associations,
                packs: packs,
                relatedProductsTitle: relatedProductsTitle,
                addToCartButtonOnAssociatedItem: addToCartButtonOnAssociatedItem,
                aspectRatio: aspectRatio,
                gridItemWidth: gridItemWidth,
                isFiveColumns: isFiveColumns,
                cardWidth: cardWidth,
                t: t,
                promotions: promotions,
                generalRes: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
                singleProductRes: singleProductRes,
                stock: stock
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeStoreModal/* default */.Z, {
                handleClose: handleCloseInStoreModal,
                open: openInStoreModal,
                doc: inStoreText,
                t: t
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMixedBasketModal/* default */.Z, {
                basket: basket
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _pack_ = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Pack));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,76142,75436,84997,50273,20355,230,19789,29705,79956,17012,18496,4998,31474,44405,49774,92888,40179], function() { return __webpack_exec__(77326); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);